import React from "react";
import Table from "../../../components/Table";
import { AoVerzekering } from "../../../../../.generated/rapportage/rapportagetypes";
import { getAovColumns } from "../../Producten/aov-kolommen";

export interface SingleAovTableProps {
  data: AoVerzekering;
}

export interface AovTableProps {
  data: AoVerzekering[];
}

export const SingleAovTable: React.FC<SingleAovTableProps> = ({
  data,
}: SingleAovTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getAovColumns({ aoVerzekering: data, isHuidig: true })}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`aov-table-${data.product?.replace(/\s+/g, "-").toLowerCase() ||
          "aov"}`}
      />
    </div>
  );
};

export const AovTable: React.FC<AovTableProps> = ({ data }: AovTableProps) => {
  return (
    <div className="aov-section">
      {data.map((aov, index) => (
        <SingleAovTable key={index} data={aov} />
      ))}
    </div>
  );
};
